export const BRAND_NAME = "Moboeat";
export const WHATSAPP = "+91-9031296761";
export const MOBILE = "+91-9031296761";
export const COPYRIGHT = "© 2025 All rights reserved. SGI Hyper Local.";
export const APP_DEBUG = true;
